import React, { useEffect, useRef, useState } from 'react';
import styles from './Modals.module.css';
import Close from 'Utils/Assets/SVGs/Close';
import { IConfirmModalProps } from '@model/AccountModeModal.model';

const ConfirmModal: React.FC<IConfirmModalProps> = ({
  open,
  setOpen,
  title = 'Confirm delete',
  message,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  onConfirm,
}) => {
  const dialogRef = useRef<HTMLDivElement | null>(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setSubmitting(false);
      setTimeout(() => dialogRef.current?.focus(), 0);
    }
  }, [open]);

  if (!open) return null;

  const handleCancel = () => {
    if (!submitting) {
      setOpen(false);
    }
  };

  const handleConfirmClick = async () => {
    try {
      setSubmitting(true);
      await onConfirm();
      setOpen(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className={styles.deleteBackdrop}
      role="presentation"
      onMouseDown={handleCancel}
      data-testid="confirm-delete-backdrop"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-title"
        className={styles.deleteDialog}
        ref={dialogRef}
        tabIndex={-1}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header className={styles.deleteHeader}>
          <h2 id="delete-title" className={styles.deleteTitle}>
            {title}
          </h2>

          <button
            type="button"
            className={styles.deleteCloseBtn}
            onClick={handleCancel}
            aria-label="Close"
          >
            <Close />
          </button>
        </header>

        <div className={styles.deleteBody}>
          <p>{message}</p>
        </div>

        <footer className={styles.deleteFooter}>
          <button
            type="button"
            className={styles.deleteCancelBtn}
            onClick={handleCancel}
            disabled={submitting}
          >
            {cancelLabel}
          </button>

          <button
            type="button"
            className={styles.deleteBtn}
            onClick={handleConfirmClick}
            disabled={submitting}
            data-testid="confirm-delete-button"
          >
            {confirmLabel}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ConfirmModal;
